import {Component, HostBinding, NgZone, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Params, Router} from "@angular/router";
import {IdexService} from "../../idex.service";
import {Toast} from "../../shared/toast/toast";
import {LoadingButtonComponent} from "../../shared/loading-button/button";
import {Observable, Subscription, timer} from "rxjs";
import {take} from "rxjs/operators";
import {TwofactorComponent} from "../../account/twofactor/twofactor.component";
import {MatLegacyDialog as MatDialog} from "@angular/material/legacy-dialog";
import {AppComponent} from "../../app.component";
import {TranslateService} from "@ngx-translate/core";


@Component({
  selector: 'app-external-sign',
  templateUrl: './external-sign.component.html',
  styleUrls: ['./external-sign.component.css']
})
export class ExternalSignComponent implements OnInit {
   @HostBinding('class') fx = 'fx-for-login flex-center';
   @ViewChild('confirmOTP') confirmOTP: LoadingButtonComponent;
   key: any = '';
   user_name: any;
   visible: boolean;
   taskId: boolean;
   ref_code: any;
   otp_code: any;
   countDown: Subscription;
   counter: number = 0;
   tick = 1000;
   email: string = '';
   isNewReq: boolean = true;

   constructor(private route: ActivatedRoute, private router: Router,
               private service: IdexService, public toast: Toast,
               private app: AppComponent, private zone: NgZone) {
   }

   ngOnInit(): void {
      this.route.params.forEach((params: Params) => {
         this.key = params['key'];
         this.taskId = params['taskid']

         if (this.key) {
            this.service.getExternalUser(this.key)
               .subscribe((data: any) => {
                  this.email = data.email;
               }, error => {
                  this.toast.error(error.message);
               });
         }
      });
   }

   onOTP() {
      this.otp_code = '';
      this.ref_code = '';
      this.isNewReq = false;
      this.counter = 60;
      this.service.getOTP(this.key)
         .subscribe((data: any) => {
            this.ref_code = data.ref_code;
            this.countDown = timer(0, this.tick)
               .pipe(take(this.counter))
               .subscribe(() => {
                  --this.counter;
                  if (this.counter == 0) {
                     this.countDown.unsubscribe();
                  }
               });
         }, error => {
            this.toast.error(error.message);
         });
   }

   transform(value: number): string {
      const minutes: number = Math.floor(value / 60);
      return (
         ('' + Math.floor(value - minutes * 60)).slice(-2)
      );
   }

   onSubmit(): void {
      const observer = this.service.verificationOTP(this.key, this.otp_code);
      this.subscribe(observer);
   }

   private subscribe(observer: Observable<any>): void {
      observer.subscribe(result => {
         this.zone.run(() => {
            this.loggedIn(result);
         });
      }, error => {
         this.confirmOTP.reset();
         this.toast.error(error.message);
      });
   }

   private loggedIn(data: any): void {
      this.service.setUser(data);
      this.app.setUser(data);
      this.router.navigate(['/extsigndoc/', this.taskId, this.key]);
   }
}
